import { AUTHORITIES } from 'app/config/constants';
import PrivateRoute from 'app/shared/auth/private-route';
import React from 'react';
import { Switch } from 'react-router-dom';
import Device from './device';
import DeviceDeleteDialog from './device-delete-dialog';
import DeviceDetail from './device-detail';
import DeviceUpdate from './device-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <PrivateRoute exact path={`${match.url}/new`} component={DeviceUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute exact path={`${match.url}/:id/edit`} component={DeviceUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute exact path={`${match.url}/:id`} component={DeviceDetail} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute path={match.url} component={Device} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
    </Switch>
    <PrivateRoute exact path={`${match.url}/:id/delete`} component={DeviceDeleteDialog} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
  </>
);

export default Routes;
